require('./client/zingchart.min.js');
zingchart.MODULESDIR = "https://cdn.zingchart.com/2.8.2/modules/";
module.exports = zingchart;



//////////////////
// WEBPACK FOOTER
// ./node_modules/zingchart/index.js
// module id = 162
// module chunks = 0